import styled from 'styled-components'
import { media } from 'styles'
import { StyledSidebar } from 'components/Sidebar'
import { StyledSwitch } from 'components/Sidebar/MobileMenu'
import StyledHeader from 'components/Header/StyledHeader'

const StyledGuestApp = styled.section`
  display: flex;
  ${StyledSidebar} {
    flex: 0 0 30vw;
  }
  ${StyledHeader} {
    min-height: 7rem;
    margin-bottom: 0;
  }
  main {
    flex: 1;
    height: 100vh;
    overflow: auto;
    overflow: overlay;
  }
  .content {
    max-width: 60vw;
    margin: auto;
  }
  ${StyledSwitch}, .profile-link {
    display: none;
  }

  ${media.mobile`
    main {
      height: initial;
    }

    .content {
      max-width: 80vw;
      margin: auto;
    }

    ${StyledHeader} {
      display: flex;
      flex-direction: column-reverse;
    }
    .section-title {
      display: block;
      margin: 2rem 0;
      width: 100%;
    }
  `}
`

export default StyledGuestApp
